<template>
  <div id="app">
    <head-Back title="无伪装版本"></head-Back>
    <div class="page">
      <div class="page-share-h5" v-if="flag">
        <div class="page-share-h5-content"   @click="toshareH5()" >
          <img src="./img/bk-dx.png" />
          <br />
          <button @click="toshareH5()">短信邀请</button>
        </div>
      </div>
      <div class="page-share" v-if="!flag">
        <div class="page-share-content page-share-content-left" @click="toshareApp(1)" >
          <img src="./img/share-wx.png" />
          <br />
          <button >微信邀请</button>
        </div>
        <div class="page-share-content page-share-content-right"  @click="toshareApp(2)">
          <img src="./img/bk-dx.png" />
          <br />
          <button >短信邀请</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import headBack from "@/components/common/head-back-down";
import { mapGetters } from "vuex";
import util from "@/utils/util";
import tips from "@/estoast";
import store from "@/store";
import wxapi from "@/utils/wxapi";

export default {
  metaInfo: {
    title: "无伪装版本"
  },
  name: "app",
  data() {
    return {
      msg: "注册协议",
      flag: true
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");
    var appFlag = this.getAppFlag;
    console.log("appFlag:" + appFlag);
    if (appFlag == true) {
      this.flag = false;
    }
  },
  methods: {
    toshareApp(num) {
      var msg = "【亲密聊APP】你的好友邀请你用一个有趣的聊天APP，快点击下载";
      var url = "http://wap.haoyunba.com/#/app/qmlResult";
      window.location.href =
        "hqml://share?shareType=" +
        num +
        "&message=" +msg
        msg +
        "&title=&url=" +
        url;
    },
    toshareH5() {
      var msg =
        "【亲密聊APP】你的好友邀请你用一个有趣的聊天APP，快点击 http://suo.im/5Lke01 下载";
         //window.location.href ="sms:10086?body="+msg;
       var  phone = '';
       var u = navigator.userAgent, app = navigator.appVersion;
        var isAndroid = u.indexOf('Android') > -1
            || u.indexOf('Linux') > -1; //android终端或者uc浏览器
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
            || u.indexOf('iPhone') > -1; //ios终端
        console.log(phone)
        if (isAndroid) {
            var sendcontent = 'sms:' + phone + '?body='+msg;//android  ///
            window.location.href = sendcontent;
        } else if (isiOS) {
            var sendcontent = 'sms:' + phone + '&body='+msg;//ios  ///
            window.location.href = sendcontent;
        } else {
            var sendcontent = 'sms:' + phone + '?body='+msg;//android  ///
            window.location.href = sendcontent;
        }   
    }
  },
  components: {
    headBack
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList",
      "getAppFlag"
    ])
  }
};
</script>
<style  scoped>
.page {
  width: 750px;
  height: 1708px;
  background: url("./img/bk-img.png");
  background-size: 100% 100%;
}

.page-share-h5 {
  width: 700px;
  height: 233px;
  margin: 726px 25px 0px;
  position: absolute;
  background: url("./img/bk-share.png");
  background-size: 100% 100%;
}
.page-share-h5-content {
  margin: 0 auto;
  height: auto;
}
.page-share-h5-content img,
.page-share-content img {
  width: 90px;
  height: 90px;
  margin-top: 35px;
}
.page-share-h5-content button,
.page-share-content button {
  width: 174px;
  height: 54px;
  font-size: 24px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: rgba(114, 47, 6, 1);
  line-height: 54px;
  background: url("./img/bk-button.png");
  background-size: 100% 100%;
  border: none;
  margin-top: 20px;
}

.page-share {
  width: 700px;
  height: 233px;
  margin: 726px 25px 0px;
  position: absolute;
}

.page-share-content {
  width: 346px;
  height: 233px;
  float: left;
  background: url("./img/share.png");
  background-size: 100% 100%;
}
.page-share-content-left {
  float: left;
}
.page-share-content-right {
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/qml/qmldown.vue